import {useEffect} from "react";
import {SubmitHandler} from "react-hook-form";
import * as specificationApi from "../../api/equipmentApi/specificationApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {FormProvider, useForm} from "react-hook-form";
import {useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {
  EQSpecification,
  initialSpecification,
} from "../../models/serverModels/equipment/EQSpecification";
import EquipmentForm from "./EquipmentForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {equipmentSchema} from "../../validation/equipmentSchema";

const CreateEquipment = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  //#region
  const {
    data: createData,
    mutateAsync: createMutate,
    isError,
  } = useCreateMutation<ResponseItem<EQSpecification>, Params.Create<EQSpecification>>({
    api: specificationApi.create,
    options: {
      onSuccess: (createData: ResponseItem<EQSpecification>) => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate("/Equipment");
        queryClient.invalidateQueries("EquipmentList");

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // createData.message.split(":")[0] === "Ok!"
        //   ? (setSnackBarToggle(true),
        //     setSnackBarState("create"),
        //     navigate("/"),
        //     queryClient.invalidateQueries("EquipmentList"))
        //   : createData.message.split(":")[0] === "failed"
        //   ? (setSnackBarToggle(true), setSnackBarState("confirm"))
        //   : (setSnackBarToggle(true), setSnackBarState("failed"));
      },
    },
  });

  // #endRegion

  const methods = useForm<EQSpecification>({
    defaultValues: initialSpecification,
    resolver: yupResolver(equipmentSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset();
  }, [reset]);

  const onSubmit: SubmitHandler<EQSpecification> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initialSpecification, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <SubTitle subTitle="설비 제원 작성" />
        <EquipmentForm />
        <ConfirmButtonGroup link="/Equipment" cancelText="취소" confirmText="저장" />
      </form>
    </FormProvider>
  );
};

export default CreateEquipment;
